<template>
    <div class="content-image">
        <div class="content-image-wrapper">
            <CmsImage
                :data="data.image"
                :is-eager="hasEagerImage"
                :sizes="['100vw', [768, '680px']]"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import CmsImage from '@/components/cms/CmsImage.vue'
import type { ComponentImageFragment } from '@/graphql/api'

defineProps<{
    data: ComponentImageFragment
    hasEagerImage?: boolean
}>()
</script>

<style lang="scss" scoped>
.content-image {
    width: 100%;
    max-width: 680px;
    margin: 0 auto;

    .content-image-wrapper {
        width: 100%;
        text-align: center;
    }
}
</style>
